import { useEffect } from 'react'

// 2-second confirmation toast. Plain green pill, anchored bottom-center.
// Kept dumb on purpose — parent owns the show/hide state so the form
// can decide *when* the toast appears.
export default function Toast({ message, onDone, duration = 2000 }) {
  useEffect(() => {
    if (!message) return
    const id = setTimeout(() => onDone?.(), duration)
    return () => clearTimeout(id)
  }, [message, duration, onDone])

  if (!message) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-24 z-50 flex justify-center px-4"
    >
      <div className="animate-fade-in rounded-full bg-green-600 px-5 py-3 text-base font-semibold text-white shadow-lg">
        {message}
      </div>
    </div>
  )
}
